'use client';

import { Icon } from '@/general/Icons/Icon';
import clsx from 'clsx';
import { FC, ReactNode } from 'react';

import { useFormStepTransition } from '@/general/transitions/FormStepTransition/FormStepTransition.context';

import { ButtonIcon } from '../../../general/components/Button/ButtonIcon';
import styles from './StepFormHeader.module.scss';

interface Props {
  /** Displayed above the title */
  suptitle?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  onBack?: (() => void) | string;
  className?: string;
  dataTestId?: string;
}

export const StepFormHeader: FC<Props> = ({ suptitle, title, subtitle, onBack, className, dataTestId }) => {
  const { navigate } = useFormStepTransition();
  const clickBack = onBack
    ? () => {
        typeof onBack === 'function' ? onBack() : navigate(onBack, true);
      }
    : undefined;

  return (
    <section className={clsx(styles.root, className)}>
      <header className={styles.header}>
        {!!suptitle && <div className={styles.suptitle}>{suptitle}</div>}
        <h1
          className={clsx(styles.title, 'c-fs-h5', 'font-extrabold')}
          data-testid={dataTestId ?? 'HYGIENE_TRADE_IN_HEADER_TITLE'}
        >
          {title}
        </h1>
        {!!subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </header>
      {!!onBack && (
        <div className={styles.buttonWrapper}>
          <ButtonIcon
            icon={<Icon name="arrow-up" />}
            title="Back"
            variant="secondary"
            size="small"
            onClick={clickBack}
            data-testid="FORM_BACK_BUTTON"
          />
        </div>
      )}
    </section>
  );
};
